import React from 'react'
import DocumentTitle from 'react-document-title'
import Spinner from 'react-spinkit'
import timeago from 'timeago.js'
import filesize from 'filesize'

import { SearchBox, Results, DownloadWidget } from '../components'
import { userStore } from '../reducers'

import torrents from '../http/proxy'
import favorites from '../http/favorites'

class SortableDateAgo {
  constructor (date) {
    this.value = date
    this.time = date * 1000
    // this.time = new Date(date).getTime()
  }
  toString() {
    return new timeago().format(this.time)
  }
  getTime() {
    return this.time
  }
}

class SortableSize {
  constructor (sizeBytes) {
    this.value = sizeBytes
  }
  toString() {
    return filesize(this.value)
  }
  getValue() {
    return this.value
  }
}

export default class SearchPage extends React.Component {
  constructor (props){
    super(props)

    this.state = {
      loading: false,
      lastQuery: '',
      lastCategory: null,
      lastTracker: null,
      searchResults: [],
      totalPages: 0,
      tags: [],
      userInfo: {
        keys: null,
      },
    }
  }

  componentWillMount() {
    // user infos
    let infos = userStore.getState()
    if (infos.data === undefined) {
      this.fetchUserInfos()
    }
  }

  fetchUserInfos() {
    torrents.get_user_info((results) => {
      userStore.dispatch({
        'type': 'INIT',
        'data': results.data,
      })
      if (results.data !== undefined) {
        this.setState({
          userInfo: {
            keys: results.data.keys,
          },
        })
      } else {
        this.setState({
          userInfo: {
            keys: null,
          },
        })
      }
    })
  }

  showResults(results, totalPages) {
    console.log(results, totalPages)
    this.setState({
      searchResults: results,
      totalPages: totalPages,
      loading: false,
    })
  }

  search(query, category=null, tracker=null, page=null, sort=null, order=null) {
    this.setState({
      lastQuery: query,
      lastCategory: category,
      lastTracker: tracker,
      loading: true,
    })
    // most fields needs to be cleaned as they are legacy T411 fields.. RIP
    torrents.search(query, category, tracker, page, sort, order, (response) => {
      let cleanedResults = []
      if (response.data) {
        cleanedResults = response.data.torrents.results
        .filter(result => typeof result === 'object')
        .map((result) => ({
          id: Number(result.id),
          name: result.title,
          detailUrl: result.web_link,
          category: result.category,
          parent_category: result.category,
          seeders: Number(result.seeds),
          leechers: Number(result.leechs),
          tracker: result.tracker,
          comments: 0,
          isVerified: 0,
          added: new SortableDateAgo(result.date),
          size: new SortableSize(result.size),
          completed: result.completed,
          owner: 0,
          categoryname: '',
          categoryimage: '',
          username: '',
          privacy: '',
          download: <DownloadWidget download={this.downloadTorrent.bind(this)} id={Number(result.id)} url={result.download_link} tracker={result.tracker} />,
        }))
      }
      let totalPages = 0
      if (response.data && response.data.torrents && response.data.torrents.stats && response.data.torrents.stats.pages) {
        totalPages = response.data.torrents.stats.pages
      }
      this.showResults(cleanedResults, totalPages)
    })
  }

  addFavorite(query, category, tags, cb) {
    let username = localStorage.getItem('username')
    favorites.add(username, query, category, tags, (status) => {
      cb(status)
    })
  }

  downloadTorrent(url, tracker, cb) {
    let username = localStorage.getItem('username')
    let userData = userStore.getState()
    let passkey = userData.data.keys[0][tracker]
    torrents.download(username, url, passkey, (status) => {
      cb(status)
    })
  }

  render() {
    return (
      <DocumentTitle title={'Café App'}>
      <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h3>Recherche {this.state.loading ? <Spinner spinnerName="three-bounce" className="col-xs-1 pull-right" noFadeIn /> : ''}</h3>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <SearchBox search={this.search.bind(this)} addFavorite={this.addFavorite.bind(this)} />
              <Results
                search={this.search.bind(this)}
                lastQuery={this.state.lastQuery}
                lastCategory={this.state.lastCategory}
                lastTracker={this.state.lastTracker}
                totalPages={this.state.totalPages}
                searchResults={this.state.searchResults}
              />
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SearchPage.js